//
//
//
//
//
//
//


export default {

    name: 'InquiryButtons',

    props: {
        backText: {
        },
        nextText: {
        },
        backStep: {
        },
        nextStep: {
        },
        skipValidation: {
            type: Boolean,
            default: false
        },

    }

}

